export var GET_ALL_INVOICES = '[Invoices] Get All';
export var GET_ALL_INVOICES_SUCCESS = '[Invoices] Get All Success';
export var GET_ALL_INVOICES_ERROR = '[Invoices] Get All Error';
export var UPDATE_INVOICE = '[Invoice] Update';
export var UPDATE_INVOICE_SUCCESS = '[Invoice] Update Success';
export var UPDATE_INVOICE_ERROR = '[Invoice] Update Error';
export var APPROVE_INVOICE_PAYMENT = '[Invoice] Approve Payment';
export var APPROVE_INVOICE_PAYMENT_SUCCESS = '[Invoice] Approve Payment Success';
export var APPROVE_INVOICE_PAYMENT_ERROR = '[Invoice] Approve Payment Error';
var GetAllInvoices = /** @class */ (function () {
    function GetAllInvoices() {
        this.type = GET_ALL_INVOICES;
    }
    return GetAllInvoices;
}());
export { GetAllInvoices };
var GetAllInvoicesSuccess = /** @class */ (function () {
    function GetAllInvoicesSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_INVOICES_SUCCESS;
    }
    return GetAllInvoicesSuccess;
}());
export { GetAllInvoicesSuccess };
var GetAllInvoicesError = /** @class */ (function () {
    function GetAllInvoicesError(payload) {
        this.payload = payload;
        this.type = GET_ALL_INVOICES_ERROR;
    }
    return GetAllInvoicesError;
}());
export { GetAllInvoicesError };
var UpdateInvoice = /** @class */ (function () {
    function UpdateInvoice(payload) {
        this.payload = payload;
        this.type = UPDATE_INVOICE;
    }
    return UpdateInvoice;
}());
export { UpdateInvoice };
var UpdateInvoiceSuccess = /** @class */ (function () {
    function UpdateInvoiceSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_INVOICE_SUCCESS;
    }
    return UpdateInvoiceSuccess;
}());
export { UpdateInvoiceSuccess };
var UpdateInvoiceError = /** @class */ (function () {
    function UpdateInvoiceError(payload) {
        this.payload = payload;
        this.type = UPDATE_INVOICE_ERROR;
    }
    return UpdateInvoiceError;
}());
export { UpdateInvoiceError };
var ApproveInvoicePayment = /** @class */ (function () {
    function ApproveInvoicePayment(payload) {
        this.payload = payload;
        this.type = APPROVE_INVOICE_PAYMENT;
    }
    return ApproveInvoicePayment;
}());
export { ApproveInvoicePayment };
var ApproveInvoicePaymentSuccess = /** @class */ (function () {
    function ApproveInvoicePaymentSuccess(payload) {
        this.payload = payload;
        this.type = APPROVE_INVOICE_PAYMENT_SUCCESS;
    }
    return ApproveInvoicePaymentSuccess;
}());
export { ApproveInvoicePaymentSuccess };
var ApproveInvoicePaymentError = /** @class */ (function () {
    function ApproveInvoicePaymentError(payload) {
        this.payload = payload;
        this.type = APPROVE_INVOICE_PAYMENT_ERROR;
    }
    return ApproveInvoicePaymentError;
}());
export { ApproveInvoicePaymentError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/actions/invoice.action.ts.pre-build-optimizer.js